<template>
  <div class="app_wrapper">
    <div class="app_title">
      <Navbar />
    </div>
    <div class="main">
      <router-view></router-view>
    </div>
  </div>

</template>

<script>
import {
  Navbar
} from './components'

export default {
  name: "layout",
  components: {
    Navbar
  },
  computed: {},
  methods: {
    getuser() {
      // console.log();
      // 判断营业时间
      let url = this.api.getuserinfo
      let methods = 'get'
      let data = {
        hotelCode: localStorage.getItem('hotelCode'),
        posCode: localStorage.getItem('posCode')
      }

      this.$axios({
        url,
        methods,
        data
      }).then(res => {
        console.log(res,'res---------wrr')
        if (!res.data.status) {
          localStorage.setItem('businessDate', res.data.data.businessDate)
        }
      })



    }
  },
  created() {
    this.getuser()
  }
};
</script>

<style lang="scss" scoped>
.app_wrapper {
  display: flex;
  height: 100%;
  width: 100%;
  flex-direction: column;
  background: #E7E8F1;

  .app_title {
    width: 100%;
    height: 80px;
    border: 1px solid #ccc;
  }

  .main {
    display: flex;
    // padding: 10px;
    height: calc(100% - 80px);
    position: relative;

    .left {
      border: 1px solid red;
      height: 100%;
      min-height: calc(100vh - 80px);
      margin-right: 10px;
      box-sizing: border-box;
      border-radius: 20px;
      max-width: 1050px;
      position: absolute;
      top: 10px;
      left: 10px;
    }

    .right {
      border: 1px solid #000;
      height: 100%;
      min-height: calc(100vh - 80px);
      border-radius: 20px;
      position: absolute;

      top: 10px;
      right: 10px;
    }
  }
}
</style>